export function OutlineCotizadorCreativeIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.029 12.4274C12.5618 11.4626 13.2338 11.1411 13.5842 9.98908C13.7378 9.48989 13.8193 8.9619 13.8193 8.40991C13.8193 5.21798 11.0546 2.67404 7.79068 3.03403C5.29954 3.31242 3.28358 5.34758 3.02919 7.84352C2.95239 8.59711 3.02919 9.31709 3.23558 9.98908C3.58117 11.1171 4.27716 11.3666 4.82915 12.461C5.09794 12.9938 5.40033 13.8242 5.40513 15.0242H11.405C11.4098 13.805 11.7266 12.9746 12.029 12.4274Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.41016 14.5496V8.66016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.07544 8.63086H9.74418"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41968 15.0483V17.0067C5.41968 18.1107 6.31246 19.0034 7.41643 19.0034H9.40839C10.5124 19.0034 11.4051 18.1107 11.4051 17.0067V15.0531C11.4051 15.0531 11.4051 15.0339 11.4051 15.0195H5.41968C5.41968 15.0195 5.41968 15.0387 5.41968 15.0435V15.0483Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0001 14.5013C20.5777 14.1989 19.6897 13.6565 18.4994 13.6661C18.005 13.6661 16.7858 13.6805 16.301 14.5013C16.0418 14.9429 15.9794 15.6437 16.301 16.1669C17.141 17.5397 19.8577 16.4645 20.6977 17.8325C21.0145 18.3508 20.9617 19.0564 20.6977 19.498C20.2321 20.29 19.0802 20.3188 18.5762 20.3332C17.3618 20.362 16.4354 19.81 16.0034 19.498"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M18.4993 12.0059V13.6714" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M18.4993 20.3379V22.0035" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}
